// extracted by mini-css-extract-plugin
export default {"slides":"Slides_slides__NqQYd","slides-container":"Slides_slides-container__+hDZV"};